import {
  Button,
  TextField,
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material'
import PageAppBar from 'components/PageAppBar'
import { base_url } from 'env'
import { useState } from 'react'
import { useLoaderData, useNavigate } from 'react-router-dom'
import { ResourceModel } from 'types'
import axios from 'axios'

export default function ResourceEditPage() {
  const resource = useLoaderData() as ResourceModel
  const navigate = useNavigate()
  const [title, setTitle] = useState(resource.title)
  const [type, setType] = useState(resource.type)

  const handleSubmit = () => {
    const token = localStorage.getItem('token')
    axios
      .put(
        `${base_url}/resource/${resource.id}`,
        { title, type },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => {
        alert('Ressource mise à jour !')
        navigate(`/resource/${resource.id}`)
      })
      .catch((err) =>
        alert('La mise à jour a échoué: ' + err.response?.data?.message)
      )
  }

  return (
    <PageAppBar pageName={`Modifier: ${resource.title}`}>
      <Box
        component="form"
        sx={{
          p: 3,
          maxWidth: '600px',
          m: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography variant="h5">Modifier la ressource</Typography>
        <TextField
          required
          fullWidth
          label="Titre"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <FormControl fullWidth>
          <InputLabel id="type-select-label">Type</InputLabel>
          <Select
            labelId="type-select-label"
            value={type}
            label="Type"
            onChange={(e) => setType(e.target.value as 'local' | 'remote')}
          >
            <MenuItem value="local">Local</MenuItem>
            <MenuItem value="remote">Distant</MenuItem>
          </Select>
        </FormControl>
        <Button variant="contained" onClick={handleSubmit} sx={{ mt: 2 }}>
          Sauvegarder
        </Button>
      </Box>
    </PageAppBar>
  )
}
